import jwtAxios from "@richbeauty/services/auth/jwt-auth/jwt-api";
import { URL_API } from "@richbeauty/services/endpoint";
import useSWR from "swr";

const getTask = async (id) => jwtAxios.get(`/${URL_API.CMS_TASKS.GET_TASK}/${id}`);

const useGetTask = (id) => {
  const fetcher = () => getTask(id);
  return useSWR(id ? { url: `/${URL_API.CMS_TASKS.GET_TASK}/${id}`, id, tags: ["#tasks"] } : null, fetcher);
};

export default useGetTask;
